import React from 'react';
import {
  Modal,
} from '@/pages/common';
import * as Styles from './ModalCreateSite.styles';
import modalDeco from '@/media/newSiteModal/modal-deco.svg';
import { Button } from '@/pages/common/v1';
import {
  IconDetailedWordpress,
  IconDetailedSiteBuilder,
} from '@/icons';
import { useResize } from '@/hooks/useResize';
import { modalCloseAction } from '../../SitesHandler/SitesHandler.enum';

const ModalCreateSite = ({
  contentDomainName = 'dominio.com.br',
  handleOnCloseWarningModal,
  buttonCreate,
  buttonClose,
  description,
  toolsText,
  title,
}) => {
  const handleOnClose = (action) => {
    handleOnCloseWarningModal && handleOnCloseWarningModal(action);
  };

  const screenSize = useResize();
  const isMobile = screenSize.width <= 600;
  const iconsSize = isMobile ? 60 : 45;

  return (
    <Modal testId="modal-create-site" maxWidth={750} disablePadding onClose={null}>
      <Styles.ContentWrapper>
        <Styles.Deco src={modalDeco} alt="Deco" />

        <Styles.Title data-testid="modal-title">
          {title}
        </Styles.Title>

        <Styles.Content data-testid="modal-description">
          {description(contentDomainName)}
        </Styles.Content>

        <Styles.Content data-testid="modal-tools-text" enableNewCreateSiteModalBehavior={false}>
          {toolsText}
        </Styles.Content>

        <Styles.Action>
          <Button testId="create-site-button" onClick={() => handleOnClose(modalCloseAction.createSite)} label={buttonCreate} />

          <Button variant="text" testId="close-modal-button" onClick={() => handleOnClose(modalCloseAction.close)} label={buttonClose} />
        </Styles.Action>

        <Styles.DecoIcons>
          <IconDetailedWordpress size={iconsSize} />

          <IconDetailedSiteBuilder size={iconsSize} />
        </Styles.DecoIcons>

        <Styles.DecoTriangle />

        <Styles.DecoLine />
      </Styles.ContentWrapper>
    </Modal>
  );
};

export default ModalCreateSite;
